module.exports = __webpack_public_path__ + "07_mustache_brown.78707bbd.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer3/07_mustache_brown.png
// module id = 57Os
// module chunks = 0